export enum EAgentOtcQueryKey {
  AGENT_OTC_GET_HISTORY = 'agent-otc-get-history',
}
